import { SAVERS } from "../actions/types";
import { takeLatest, call, put, takeEvery } from "redux-saga/effects";
import {
  viewSaverSuccess,
  clearInfo,
  createGoalSuccess,
  createGoalFail,
  countSaversSuccess,
  countSavers,
  viewSaversSuccess
} from "../actions/Savers";
import history from "../../helpers/history";
import { loadingFetch, loadingFinish } from "../actions/Loading";
import axios from "axios";
import { toast } from "react-toastify";
import { logout } from "../actions/Auth";
import { accLoadingFinish } from "../actions/accLoading";
import { updateProfile } from "../actions/Settings";

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}agent`;

function* handleViewSaver({ payload }) {
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiUrl = `${API_BASE}/saver/view`;

  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          ...payload,
        },
      });

      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      yield put(viewSaverSuccess(result.data.data));
    } else {
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleCreateSaver({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/saver/create`;
  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "success") {
      // yield put(createSaverSuccess());
      // yield put(updateProfile());
      yield put(countSavers(payload.user_id));
      toast.success(result.data.message);
      history.push("/agent/savers/saving/goal/create");
      yield put(clearInfo);
    } else {
      let errorMessage = result.data.message;
      throw errorMessage;
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.status === 400) {
        for (const property in err.response.data) {
          toast.error(`${err.response.data[property]}`);
        }
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleCreateGoal({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiUrl = `${API_BASE}/saver/saving/goal/create`;
  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    //  yield put(createGoalSuccess())
    //  toast.success("Saving Goal Created")
    yield loadingFetch();
    const result = yield call(apiCall);

    if (result.data.status === "success") {
      //success conditions
      //logic call create saving goal after
      yield put(createGoalSuccess());
      toast.success(result.data.message);

      history.push("/agent/savers");
    } else {
      //set error message from api response
      let errorMessage = result.data.message;
      throw errorMessage;
    }
  } catch (err) {
    let error = err;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
    yield put(createGoalFail());
  } finally {
    yield put(loadingFinish());
  }
}

function* handleDeposit({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiUrl = `${API_BASE}/saver/deposit`;
  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      yield put(updateProfile());
      sessionStorage.setItem("message", result.data.message);
      sessionStorage.setItem("disable", true)
        history.push("/agent/savers");
    } else {
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    sessionStorage.removeItem("saver-deposit");
    sessionStorage.removeItem("amount")
    yield put(loadingFinish());
  }
}

function* handleWithdraw({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiUrl = `${API_BASE}/saver/withdraw`;
  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      yield put(updateProfile());
      sessionStorage.setItem("message", result.data.message);
      sessionStorage.removeItem("withdraw-info");
      sessionStorage.setItem("disable", true)
      history.push("/agent/savers");
    } else {
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleCountSavers({ payload }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const config = {
    method: "get",
    url: `${API_BASE}/saver/count`,
    params: { user_id: payload },
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  const apiCall = async () => {
    try {
      const result = await axios(config);

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.data.no_of_savers)
      yield put(countSaversSuccess(result.data.data.no_of_savers));
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
      toast.error(error);
    }
  } finally {
    yield put(loadingFinish());
  }
}

function* handleWithdrawViewSaver({ payload }) {
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiUrl = `${API_BASE}/saver/view`;

  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          ...payload,
        },
      });

      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      sessionStorage.setItem("withdraw-info", JSON.stringify(result.data));
    } else {
      sessionStorage.removeItem("withdraw-info");
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(accLoadingFinish());
  }
}

function* handleSendOtp({ payload }) {
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiUrl = `${API_BASE}/sms/otp`;

  const apiCall = async () => {
    try {
      const result = await axios.post(
        apiUrl,
        {
          user_id: payload.id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      sessionStorage.setItem("message", result.data.message);
      sessionStorage.setItem("amount", payload.amount)
      history.push("/agent/savers/withdraw/confirm")
    } else {
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleResendOtp({ payload }) {
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiUrl = `${API_BASE}/sms/otp/resend`;

  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          user_id: payload,
        },
      });

      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      toast.success(result.data.message);
    } else {
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleViewSavers({ payload }) {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const apiUrl = `${API_BASE}/saver/list`;

  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          ...payload,
        },
      });
      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "error") {
      toast.error(result.data.message);
    } else {
      yield put(viewSaversSuccess(result.data.data));
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

const saversSaga = [
  takeLatest(SAVERS.VIEW, handleViewSaver),
  takeEvery(SAVERS.CREATE, handleCreateSaver),
  takeEvery(SAVERS.CREATE_GOAL, handleCreateGoal),
  takeEvery(SAVERS.COUNT, handleCountSavers),
  takeEvery(SAVERS.DEPOSIT, handleDeposit),
  takeEvery(SAVERS.WITHDRAW, handleWithdraw),
  takeEvery(SAVERS.WITHDRAW_VIEW_SAVER, handleWithdrawViewSaver),
  takeEvery(SAVERS.SEND_OTP, handleSendOtp),
  takeLatest(SAVERS.RESEND_OTP, handleResendOtp),
  takeLatest(SAVERS.VIEW_SAVERS, handleViewSavers)
];

export default saversSaga;
